import React, { useReducer, useEffect } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

import { validate } from '../../../utils/validators';

import './Interruptor.css';

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};

export default function Interruptor(props) {
  const {
    id,
    name,
    label,
    onInput,
    validators,
    dica,
    initialValue,
    initialValid,
  } = props;
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: !!initialValue,
    isValid: !!initialValid,
    isTouched: !!initialValid
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const handleChange = (event) => {
    dispatch({ type: 'CHANGE', val: event.target.checked, validators });
  };

  return (
    <FormGroup row className="interruptor">
      <FormControlLabel
        control={<Switch checked={inputState.value} onChange={handleChange} name={name} />}
        label={label}
      />
      {dica && (<span className="dica">{dica}</span>)}
    </FormGroup>
  );
}
